import { AxiosResponse } from "axios";

import { GenericObject } from "@aeo/core/types";
import { stringifyUrl } from "@aeo/core/api/utils";
import models from "@aeo/core/models";
import { apiAxios } from "@aeo/core/api/axios";

export const users = {
  get: async (query: GenericObject = {}) => {
    const url = stringifyUrl(`/aeo/management/users`, query);
    const { data } = await apiAxios.get<models.WithResults<models.User>>(url);

    return data;
  },

  getById: async (id: string) => {
    const { data } = await apiAxios.get(`/aeo/management/users/${id}`);
    return data;
  },

  createUser: async (credentials: models.User) => {
    await apiAxios.post<models.User, AxiosResponse<models.TokensResponse>>(
      `/aeo/management/users/create`,
      credentials,
    );
  },

  editUser: async ({ id, ...data }: models.User) => {
    await apiAxios.patch<models.User, AxiosResponse<models.TokensResponse>>(
      `/aeo/management/users/${id}`,
      data,
    );
  },

  deleteUser: async (id: number) => {
    return await apiAxios.delete<void>(`/aeo/management/users/${id}`);
  },

  blockUser: async (id?: number) => {
    const { data } = await apiAxios.post<
      { id: number },
      AxiosResponse<models.ResponseWithSuccess>
    >(`/aeo/management/users/${id}/block`);
    return data;
  },

  unblockUser: async (id?: number) => {
    const { data } = await apiAxios.post<
      { id: number },
      AxiosResponse<models.ResponseWithSuccess>
    >(`/aeo/management/users/${id}/unblock`);
    return data;
  },

  resendConfirmation: async (username: string) => {
    const { data } = await apiAxios.post<
      { username: string },
      AxiosResponse<models.ResponseWithSuccess>
    >("/aeo/management/users/resend-confirmation", {
      username,
    });
    return data;
  },
};
